import React, {useEffect, useState} from "react";
import {FormProvider} from "react-hook-form";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {useAuth} from "../../../../hooks/useAuth";
import {ISearchForm} from "../pages/SchoolReportGenerate";
import {APIGetAllClassrooms} from "../../../classrooms/api/classrooms";
import {getRomanNumber} from "../../../../utils/functions";
import FormLabelBox from "../../../../shared/ui/FormLabelBox";
import FormFieldBox from "../../../../shared/ui/FormFieldBox";
import Loading from "../../../../shared/ui/Loading";
import CustomButton from "../../../../shared/ui/CustomButton";
import CustomDatePicker from "../../../../shared/form/CustomDatePicker";
import FormField from "../../../../shared/form/FormField";
import RadioField from "../../../../shared/form/RadioField";
import moment from "moment";

const newStandardsDate = process.env.REACT_APP_STANDARDS_DATE ?? new Date();

const SchoolReportForm = ({
                    startDate,
                    endDate,
                    onDateRangeChange,
                    selectClassroomHandler,
                    onSubmit,
                    tags,
                    methods,
                    classroomId,
                    type,
                    isStandard,
                    handleSelectChange,
                    subjects,
                } : ISearchForm) => {
    const {update} = useAuth();
    const [classrooms, setClassrooms] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if(classroomId) return;

        setLoading(true);
        APIGetAllClassrooms()
            .then((response) => {
                if (response.data.success) {
                    // console.log("getClassroom OK", response);
                    setClassrooms(
                        response.data.data.items.map((item: { name: string; id: string, grade: number }) => {
                            return {
                                label: `(${getRomanNumber(item.grade)}) ${item.name}`,
                                value: item.id,
                                ...item,
                            };
                        }),
                    );
                    setLoading(false);
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch((err) => {
                // console.log("getClassroom ERR", err);
                update("error", {show: true, code: "A001"});
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                <Grid container spacing={1.5} alignItems="center">

                    {!classroomId && type === "classroom" && (
                        <>
                            <FormLabelBox title="Clasa:" />

                            <FormFieldBox>
                                {loading ? (
                                    <Loading show={true}/>
                                ) : classrooms.length === 0 ? (
                                    <Box>Nicio clasă introdusă în platformă.</Box>
                                ) : (
                                    <FormField
                                        name="classroom"
                                        type="autocomplete-controlled"
                                        label="Alege clasa"
                                        multiple={false}
                                        options={classrooms}
                                        errorMessage={methods.formState.errors.classroom?.message}
                                        onChange={selectClassroomHandler}
                                        disableClearable={true}
                                    />
                                )}
                            </FormFieldBox>
                        </>
                    )}

                    <FormLabelBox title="Materie:" />

                    <FormFieldBox>
                        <FormField
                            name="subject"
                            type="select"
                            label="Alege materia"
                            defaultValue=""
                            options={subjects}
                            errorMessage={methods.formState.errors.subject?.message}
                            error={!!methods.formState.errors.subject?.message}
                        />
                    </FormFieldBox>

                    <FormLabelBox title="Tag:" />

                    <FormFieldBox>
                        <FormField
                            name="tag"
                            type="autocomplete"
                            label="Alege tagul"
                            multiple={true}
                            defaultValue={[]}
                            options={tags.map((item: string) => {
                                return {
                                    label: item,
                                    value: item,
                                };
                            })}
                            errorMessage={methods.formState.errors.tag?.message}
                            disableClearable={true}
                            error={!!methods.formState.errors.tag?.message}
                            limitTags={4}
                        />
                    </FormFieldBox>

                    <FormLabelBox title="Perioadă:" />

                    <FormFieldBox>
                            <CustomDatePicker
                                name="interval"
                                startDate={startDate}
                                endDate={endDate}
                                onDateChange={onDateRangeChange}
                                type="dateRangePicker"
                                minDate={ isStandard === "0"
                                    ? new Date(newStandardsDate)
                                    : undefined}
                                maxDate={isStandard === "0" ?  undefined : (() => {
                                    const d = new Date(newStandardsDate);
                                    d.setDate(d.getDate() - 1);
                                    return d;
                                })()}
                                small={false}
                                errorMessage={methods.formState.errors.interval?.message}
                                error={!!methods.formState.errors.interval?.message}
                            />
                    </FormFieldBox>

                    {type === "classroom" && (
                        <>
                            <FormLabelBox title="" />
                            <FormFieldBox>
                                <RadioField
                                    row={true}
                                    defaultValue={isStandard}
                                    onChange={handleSelectChange}
                                    name="individual_test"
                                    columns={false}
                                    options={[
                                        {
                                            label: `Teste efectuate din data de ${moment(newStandardsDate).locale("ro").format("DD.MM.YYYY")}`,
                                            value: 0,
                                        },
                                        {
                                            label: `Teste efectuate până la data de ${moment(newStandardsDate).locale("ro").format("DD.MM.YYYY")}`,
                                            value: 1,
                                        },
                                    ]}
                                    error={methods.formState.errors.classroom?.message}
                                />
                            </FormFieldBox>
                        </>
                    )}


                    <FormLabelBox />

                    <FormFieldBox>
                        <CustomButton
                            bgcolor="dark"
                            submit
                            buttonType="textIcon"
                        >
                            Generează Raport
                        </CustomButton>
                    </FormFieldBox>
                </Grid>
            </form>
        </FormProvider>
    )
}

export default SchoolReportForm;